import axios from 'axios';
import { CONFIG } from '../config';
import { UserModel } from '../models';
import { PharmacyDetailModel, PharmacyModel } from './../models/pharmacy';
import { isAdmin } from './account';
import client from "./base"

export type IGetListPharmacyRequest = {
    mName: string
    offset: number
    limit: number
    adminId: string
}

export const getListPharmacy = async (params: IGetListPharmacyRequest) => {
    return await client.get(
        `${process.env.REACT_APP_API_BASE_URL}/admins/${params.adminId}/pharmacies`,
        { params }
    ).then((res) => {
        return res?.data?.map((item: any) => new PharmacyModel(item))
    })
}

export type IGetDetailPharmacy = {
    pharmacyCode: string
}

export const getDetailPharmacy = async (params: IGetDetailPharmacy) => {
    let path = ''

    if (isAdmin()) {
        path = `${process.env.REACT_APP_API_BASE_URL}/admin/pharmacy/detail/pharmacy-code/${params.pharmacyCode}`
    } else {
        path = `${process.env.REACT_APP_API_BASE_URL}/pharmacy/${params.pharmacyCode}`
    }

    return await client.get(path)
        .then(res => {
            return new PharmacyDetailModel({
                ...res?.data,
                address: res?.data?.address || res?.data?.pharmacyAddress,
                pharmacyAddress: res?.data?.pharmacyAddress || res?.data?.address
            })
        })
}

export const getPharmacyInfoLocal = () => {
    const jsonPharmacyInfo: any = localStorage.getItem(CONFIG.PHARMACY_INFO)
    return JSON.parse(jsonPharmacyInfo) as {
        pharmacyCode: string,
        pharmacyId: number,
        pharmacyData?: PharmacyModel
    }
}

export const getPharmacistByToken = async (token: string) => {
    return await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/pharmacist/getPharmacistWithPharmacyData`,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    ).then(res => {
        return {
            pharmacy: new PharmacyModel({
                ...res.data,
                mName: res.data.mPharName,
                mId: res.data.mPharId
            }),
            doctor: new UserModel({
                ...res.data,
            })
        }
    })
}

interface IPharmacyLocalInfo {
    pharmacyId: string,
    pharmacyCode: string,
    pharmacyData: PharmacyModel
}

export const setCurrentPharmacy = async (pharmacyInfo: IPharmacyLocalInfo | null) => {
    if (pharmacyInfo) {
        localStorage.setItem(CONFIG.PHARMACY_INFO, JSON.stringify(pharmacyInfo))
    } else {
        localStorage.removeItem(CONFIG.PHARMACY_INFO);
    }
}